import { render, staticRenderFns } from "./CarRequests.vue?vue&type=template&id=64e9917e&scoped=true"
import script from "./CarRequests.vue?vue&type=script&lang=js"
export * from "./CarRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9917e",
  null
  
)

export default component.exports